import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useHistory, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getBooth, getBooths } from '../ducks/booth'
import Amplitude from '../utils/amplitudeHelper'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { fixedAssets } from 'src/containers/PreCache'
import PageWithBg from 'src/components/PageWithBg'
import BackToHomeButton from 'src/components/BackToHomeButton'
import IframeModal from 'src/components/GlobalModals/IframeModal'
import VideoModal from 'src/components/GlobalModals/VideoModal'
import PosterModal from 'src/components/GlobalModals/PosterModal'
import DownloadModal from 'src/components/GlobalModals/DownloadModal'
import { DocumentViewer } from 'src/components/GlobalModals/DocumentViewer'
import TawkModal from 'src/components/GlobalModals/TawkModal'
import { loadTawk } from '../utils/tawkToHelper'

const Page = styled.div`
  overflow: hidden;
  color: #505c7c;

  #button-container {
    position: absolute;
    bottom: 4vh;
    left: 2%;
  }
  .booth-container {
    position: fixed;
    height: 85vh;
    width: 95vw;
    max-width: 1380px;
    min-height: 600px;
    top: 80%;
    left: 50%;
    transform: translate(-50%, -80%);
    display: flex;
    opacity: 0;
    animation: appear 500ms 500ms forwards;
    .booth-img {
      object-fit: contain;
      height: 100%;
      width: 100%;
    }
    .hot-actions {
      border-radius: 50%;
      padding: 0;
      img {
        transition: all 500ms;
        width: 80px;
        height: 80px;
      }
      &:hover {
        img {
          transform: scale(1.1);
        }
      }
    }
  }
  #baseLayer {
    position: fixed;
    inset: 0; 
    top: 50%;
    animation: slideIn 800ms 800ms forwards;
  }
  @keyframes slideIn {
    to { top: 5%; }
  }
  #boothKv {
    position: fixed;
    top: 0%;
    left: 0%;
    width: 20%;
    transition: all 500ms ease-in;
    animation: floating 5s infinite linear;
  }
  .back-to-home {
    position: fixed;
    top: 10%;
    right: 10%;
    z-index: 100;
  }
  .navigateBooths {
    position: fixed;
    bottom: 15%;
    right: 2%;
    
    button {
      background: linear-gradient(125deg, #b98316, #fef1a0, #b98316);
      color: #000;
      padding: 8px 8px;
      width: 150px;
      border: none;
      display: flex;
      margin-bottom: 12px;
      align-items: center;
      transition: all 200ms ease-in;
      svg {
        transition: 500ms;
        width: 25px;
        height: 25px;
      }
      small {
        display: block;
        margin-left: 4px;
        font-size: 70%;
      }
      &:hover {
        transform: scale(1.1);
      }
    }
  }
`
const HotButton = styled.div`
  position: absolute;
  ${(props) => props.css}
  cursor: pointer;
`

export const boothKV = [fixedAssets.growthBright, fixedAssets.comfortBright, fixedAssets.cognitionBright]
const EMBED_DIV_ID = 'TAWK_EMBED'

export default function BoothPage({ currentUser }) {
  const history = useHistory()
  const [showBtn, setShowBtn] = useState(false)
  const dispatch = useDispatch()
  const { boothId } = useParams()
  const { viewBooth, booths } = useSelector((state) => state.booth)

  const [iframeOpen, setIframeOpen] = useState(false)
  const [posterOpen, setPosterOpen] = useState(false)
  const [downloadOpen, setDownloadOpen] = useState(false)
  const [videoOpen, setVideoOpen] = useState(false)
  const [playVideo, setPlayVideo] = useState({})
  const [documentSelected, setDocumentSelected] = useState(null)
  const [tawkOpen, setTawkOpen] = useState(false)
  const [isCustom, setIsCustom] = useState(false)

  useEffect(() => {
    dispatch(getBooth(boothId))
  }, [boothId, dispatch])

  useEffect(() => {
    if (viewBooth && viewBooth.id == boothId) {
      dispatch(getBooths(viewBooth.hall.id))
      Amplitude.visitBooth(viewBooth.title)
    }
  }, [boothId, currentUser.id, dispatch, viewBooth])

  const handleModal = (video) => {
    Amplitude.watchBoothVideo(video.filename)
    setPlayVideo(video)
    setIframeOpen(true)
    setVideoOpen(false)
  }

  const handleDownload = () => {
    Amplitude.clickHotButtons(viewBooth.title, 'pdf')
    setDownloadOpen(!downloadOpen)
  }

  const handleVideoModal = (type="") => {
    setIsCustom(type === 'custom' ? true : false)
    Amplitude.clickHotButtons(viewBooth.title, 'video')
    setVideoOpen(!videoOpen)
  }

  const handlePoster = (type) => {
    Amplitude.clickHotButtons(viewBooth.title, type)
    setPosterOpen(!posterOpen)
  }

  const openTawk = () => {
    if (viewBooth) {
      Amplitude.clickHotButtons(viewBooth.title, 'chat')
      const { chat_link } = viewBooth
      loadTawk(currentUser, chat_link, EMBED_DIV_ID)
      setTawkOpen(!tawkOpen)
    }
  }
  const navigatePrev = () => {
    setShowBtn(false)
    const navigateTo = booths.filter(booth=>booth.order===viewBooth.order-1)[0].id
    history.push(`/booths/${navigateTo}`)
  }
  const navigateNext = () => {
    setShowBtn(false)
    const navigateTo = booths.filter(booth=>booth.order===viewBooth.order+1)[0].id
    history.push(`/booths/${navigateTo}`)
  }
  return (
    <Page>
      <PageWithBg bgImg={fixedAssets.boothBg} style={{ opacity: showBtn ? 1 : 0}}>
        <img id="boothKv" src={boothKV[boothId == 35 ? 2 : boothId-1]} alt="booth visual" />
        <img id="baseLayer" src={fixedAssets.boothBase} width="100%" alt="base layer" />
        <div className='back-to-home'>
          <BackToHomeButton />
        </div>
        {viewBooth && 
          <div className="booth-container" >
            <LazyLoadImage
              effect="black-and-white"
              afterLoad={() => setShowBtn(true)}
              className="booth-img"
              src={viewBooth.background_image.url}
              width="100%"
              alt="booth image"
              style={{ opacity: showBtn ? 1 : 0}}
            />
            {showBtn && (
              <>
                {viewBooth.booth_videos.length > 0 &&
                  <HotButton css={viewBooth.button_position.tv} className="hot-actions" onClick={() => handleVideoModal('normal')} >
                    <img src={fixedAssets.boothVideo} alt="Nav" />
                  </HotButton>
                }
                {viewBooth.id === 1 &&
                  <HotButton css={viewBooth.button_position.sp} className="hot-actions" onClick={() => handleVideoModal('custom')} >
                    <img src={fixedAssets.boothVideo} alt="Nav" />
                  </HotButton>
                }
                {viewBooth.documents.length > 0 && 
                  <HotButton css={viewBooth.button_position.pdf} className="hot-actions" onClick={handleDownload}>
                    <img src={fixedAssets.boothPdf} alt="Nav" />
                  </HotButton>
                }
                {viewBooth.wallpaper_gallery.length > 0 &&
                  <HotButton css={viewBooth.button_position.wp} className="hot-actions" onClick={()=>handlePoster("wallpaper")}>
                    <img src={fixedAssets.boothViewer} alt="Nav" />
                  </HotButton>
                }
                {/* <HotButton css={viewBooth.button_position.chat} className="hot-actions" onClick={openTawk}>
                  <img src={fixedAssets.boothChat} alt="Nav" />
                </HotButton> */}
              </>
            )}
            <div className='navigateBooths'>
              {viewBooth.order !== 0 && (
                <button className="nav-btn" onClick={navigatePrev}>
                  <svg width="17.301" height="26.839" viewBox="0 0 17.301 26.839">
                    <g transform="translate(17.301 26.839) rotate(180)">
                      <path d="M.459,14.462,13.147,26.407a1.637,1.637,0,0,0,2.216,0l1.48-1.393a1.415,1.415,0,0,0,0-2.084L6.79,13.419,16.845,3.909a1.415,1.415,0,0,0,0-2.084L15.363.432a1.637,1.637,0,0,0-2.216,0L.459,12.376A1.415,1.415,0,0,0,.459,14.462Z" transform="translate(17.301 26.839) rotate(180)" fill="#000"/>
                    </g>
                  </svg>
                  <small>Previous Booth</small>
                </button>
              )}
              {viewBooth.order !== booths.length-1 && (
                <button className="nav-btn" onClick={navigateNext}>
                  <svg width="17.301" height="26.839" viewBox="0 0 17.301 26.839">
                    <path d="M.459,12.376,13.147.432a1.637,1.637,0,0,1,2.216,0l1.48,1.393a1.415,1.415,0,0,1,0,2.084L6.79,13.419,16.845,22.93a1.415,1.415,0,0,1,0,2.084l-1.48,1.393a1.637,1.637,0,0,1-2.216,0L.459,14.462A1.415,1.415,0,0,1,.459,12.376Z" transform="translate(17.301 26.839) rotate(180)" fill="#000"/>
                  </svg>
                  <small>Next Booth</small>
                </button>
              )}
            </div>
            <VideoModal videos={isCustom ? viewBooth.booth_videos.slice(2, 4) : boothId == 1 ? viewBooth.booth_videos.slice(0,2) : viewBooth.booth_videos} setVideoOpen={setVideoOpen} videoOpen={videoOpen} handleModal={handleModal} />
            {iframeOpen &&  <IframeModal iframeOpen={iframeOpen} setIframeOpen={setIframeOpen} iframe={playVideo} />}
            <DownloadModal setDocumentSelected={setDocumentSelected} files={viewBooth.documents} setDownloadOpen={setDownloadOpen} downloadOpen={downloadOpen} />
            <PosterModal images={viewBooth.wallpaper_gallery} posterOpen={posterOpen} setPosterOpen={setPosterOpen} />
            {documentSelected && <DocumentViewer file={documentSelected} setDocumentSelected={setDocumentSelected} />}
            <TawkModal embedId={EMBED_DIV_ID} tawkOpen={tawkOpen} setTawkOpen={setTawkOpen}/>  
          </div>
        }
      </PageWithBg>
    </Page>
  )
}
